<template>
  <div>
    <Head title="Ofertas de trabajo"></Head>
    <div class="container pt-2 pt-lg-4">
      <h1>Bienvenido/a, {{ name }}</h1>
      <div class="lpg-form px-3">
          <h2 class="mt-2 mb-5 lpg-form-title text-start">OFERTAS DE TRABAJO DE LA EMPRESA</h2>                    
          <div class="lpg-content-list">
              <div class="row">        
                <div v-for="(jobposting, key) in jobpostings" :key="key" class="col-12 col-md-6">
                  <Link
                    :class="['lpg-media-link', $page.url === '/' ? 'active' : '']"
                    aria-current="page"
                    :href="$route('company.ofertas.show',jobposting['id'])"
                  >
                    <div class="lpg-media-list d-flex align-items-center">
                      <img src="/images/bolsa-img.png" class="img-fluid" alt="..." />
                      <div class="lpg-media-body">
                        <h4 class="lpg-media-title">{{jobposting['title']}}</h4>
                         <p class="lpg-media-desc"> {{jobposting['category']['name']}}</p>
                         <h1 class="lpg-media-desc"> {{jobposting['short_description']}}</h1>                       
                      </div>
                    </div>
                  </Link>
                </div>
              </div>                       
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head,Link } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput'

export default {
  name: 'CompanyJobPostingIndex',
  layout: LayoutEmpresas,
  components: { Head, TextInput,Link },
  props: {
    jobpostings: Array,
  },
  data() {
    return {
    }
  },
  computed: {
    name() {
      return this.$page.props.auth.profile.fullname.split(' ')[0]
    },
  },
}
</script>

<style scoped>
.card-gradient {
  background: linear-gradient(90deg, #f8ff00 0%, #3ad59f 100%);
}
</style>
